module.exports = __webpack_public_path__ + "img/31exp.78083064.jpg";